export default func => (...args) => new Promise((resolve, reject) => func(resolve, reject, ...args));
